import { UserType } from 'src/graphql';

export const canManageCases = (viewer: UserType | null): boolean => {
  if (!viewer) return false;

  const hasManageCases =
    viewer.Accounts?.some(
      (account) =>
        account.Roles?.some(
          (role) =>
            role.SystemPermissions?.some(
              // eslint-disable-next-line max-nested-callbacks
              (permission) => permission.permission === 'MANAGE_CASES',
            ) ?? false,
        ) ?? false,
    ) ?? false;

  return hasManageCases;
};
